import { Field } from '@chakra-ui/react';
import { AddressElement } from '@stripe/react-stripe-js';
import { StripeAddressElementChangeEvent } from '@stripe/stripe-js';
import { useFormContext } from 'react-hook-form';
import FieldErrorMessage from 'src/components/input/FieldErrorMessage';

export default function Address() {
  const {
    watch,
    formState: { errors },
    setValue,
    trigger,
  } = useFormContext();

  const showVatFields = watch('showVatFields');

  const onAddressChange = (event: StripeAddressElementChangeEvent) => {
    setValue('address', {
      name: event.value.name,
      complete: event.complete,
      ...event.value.address,
    });
    if (event.complete) {
      trigger('address');
    }
  };

  if (!showVatFields) return null;

  // @ts-ignore - address has a complete property
  const addressCompleteError = errors.address?.complete?.message;

  const country = watch('country');

  if (!country) return null;

  return (
    <Field.Root invalid={!!addressCompleteError} css={{ '& .StripeElement': { width: '100%' } }}>
      <AddressElement
        key={`vat-${country}`}
        options={{
          mode: 'billing',
          display: { name: 'organization' },
          allowedCountries: [country],
        }}
        onChange={onAddressChange}
      />
      <FieldErrorMessage>{addressCompleteError}</FieldErrorMessage>
    </Field.Root>
  );
}
